/* eslint-disable @typescript-eslint/no-unused-vars */
import { Anchor, Card, Image } from '@enterprise-ui/canvas-ui-react'
import { isEmpty } from 'validate.js'
import activitiesFeed from '../JoyrideImages/activityFeed.png'
import loadView from '../JoyrideImages/loadView.png'
import poTroubleshooting from '../JoyrideImages/poTroubleShooting.png'

// To allow a specific user role to see a particular announcement, simply add the role type to the `visibleTo` array for that feature.
const newLocationUpdateFeatures = [
  {
    title: 'PO Troubleshooting',
    description: (
      <div className="hc-lh-md hc-ta-left hc-color-black">
        <div className="hc-pa-md hc-color-black">
          <div className="hc-mb-sm"></div>
          <div className="hc-pb-sm hc-color-black">
            <strong className="hc-color-black">PO Troubleshooting</strong>
          </div>
          <p className="hc-pb-sm hc-color-black">
            There can be a variety of reasons why a specific purchase order is
            not available in ShipIQ. The PO Troubleshooting tab is now available
            to help! Enter a PO number to get a list of shipments associated
            with the PO or the reason why the PO is not available, including
            recommended next steps if further information is required.
          </p>
        </div>
      </div>
    ),
    src: poTroubleshooting,
    width: '1000px',
    height: '400px',
    component: 'img',
    visibleTo: ['MERCH_VENDOR', 'INTERNAL'],
  },

  {
    title: 'Activity Feed',
    description: (
      <div className="hc-lh-md hc-ta-left">
        <div className="hc-pa-md">
          <div className="hc-mb-sm"></div>

          <div className="hc-pb-sm">
            Every shipment now has an activity icon. When you click this icon,
            you will be able to see the various activities which have occurred
            for that shipment within ShipIQ, who took the action, and when the
            action occurred.
          </div>

          <div className="hc-pb-sm">
            <strong>Future Enhancements Being Explored:</strong>
          </div>
          <ul className="hc-pb-sm">
            <li>
              Ability to view load assignment history from Target's routing
              application
            </li>
            <li>
              Ability to view the history of the load including details such as
              when the load was assigned to a carrier, accepted by the carrier,
              and picked up.
            </li>
          </ul>
        </div>
      </div>
    ),
    src: activitiesFeed,
    width: '1000px',
    height: '560px',
    component: 'img',
    visibleTo: ['ALL'],
  },
  {
    title: 'Load View',
    description: (
      <div className="hc-lh-md hc-ta-left">
        <div className="hc-pa-md">
          <div className="hc-mb-sm"></div>

          <div className="hc-pb-sm">
            Sometimes you need to research or prepare shipments related to a
            specific Load ID. While this can be difficult using the 'Purchase
            Orders' view, the 'Loads' view is now available!
          </div>

          <div className="hc-pb-sm">
            Simply enter a Load ID to search for all of your shipments on that
            load.
          </div>

          <div className="hc-pb-sm">
            <strong>Future Enhancements Being Explored:</strong>
          </div>
          <ul className="hc-pb-sm">
            <li>Ability to search by shipping location and date range</li>
            <li>
              Display the same shipping location details provided on the
              'Purchase Orders' view
            </li>
            <li>Ability to export shipment details</li>
          </ul>
        </div>
      </div>
    ),
    src: loadView,
    width: '1000px',
    height: '407px',
    component: 'img',
    visibleTo: ['MERCH_VENDOR', 'INTERNAL'],
  },
  // Survey announcement - currently disabled
  // To enable: Change visibleTo array to include actual roles like ['INTERNAL', 'MERCH_VENDOR', etc.]
  {
    title: 'Survey for ShipIQ Users',
    description: (
      <div className="hc-lh-md hc-ta-left">
        <div className="hc-pa-md">
          <div className="hc-mb-sm"></div>

          <div>Attention ShipIQ Users,</div>
          <div className="hc-pb-sm">
            We are excited to announce that our quarterly survey is now open! We
            look forward to gathering your valuable feedback on our application.
            The survey will help us understand how to best serve and improve the
            user experience, and your input is crucial in this process.
          </div>
          <div>
            The survey should only take 5 to 10 minutes of your time and can be
            accessed via the following link:{' '}
            <Anchor
              target="blank"
              rel="noreferrer"
              href="https://survey.medallia.com/?target-sus&product=target_sus_product_shipiq"
            >
              https://survey.medallia.com/?target-sus&product=target_sus_product_shipiq
            </Anchor>
          </div>
          <div className="hc-pb-sm">
            We appreciate your continued support and look forward to hearing
            your thoughts. Thank you for taking the time to complete the survey.
          </div>
          <div className="hc-pb-sm">Best Regards,</div>
          <div>ShipIQ Product Team</div>
        </div>
      </div>
    ),
    visibleTo: ['SURVEY_ENABLED'], // Special role that doesn't exist - change to 'ALL' to make visible to everyone
  },
]

const renderCardMedia = (step: any) => (
  <div className="hc-d-flex hc-jc-center hc-w-100 hc-color-black">
    <Card
      corners="none"
      variant="transparent"
      className="hc-w-100 hc-of-auto hc-pa-xs hc-color-black"
      style={{
        maxHeight: '600px',
        maxWidth: '100%',
        width: '100%',
        backgroundColor: 'transparent',
        border: 'none',
        boxShadow: 'none',
      }}
    >
      {!isEmpty(step.src) && (
        <div
          className="hc-d-flex hc-jc-center hc-w-100 hc-color-black"
          style={{
            marginTop: step.title === 'PO Troubleshooting' ? '50px' : '0',
          }}
        >
          <Image
            alt={step.alt || step.title}
            src={step.src}
            width="100%"
            height={step.height}
            type={step.type}
            className="hc-of-contain"
            style={{
              width: '100%',
              maxWidth: '100%',
              maxHeight: '600px',
              objectPosition:
                step.title === 'PO Troubleshooting'
                  ? 'center top'
                  : 'center center',
              border: 'none',
              boxShadow: 'none',
            }}
          />
        </div>
      )}
    </Card>
  </div>
)

function userHasRole(userInfo: any, role: string) {
  switch (role) {
    case 'INTERNAL':
      return userInfo.isInternal
    case 'EXTERNAL':
      return userInfo.isExternal
    case 'MERCH_VENDOR':
      return userInfo.isMerchVendorUser
    case 'CONSOLIDATOR':
      return userInfo.isConsolidatorUser
    case 'REVERSE_LOGISTICS':
      return userInfo.isReverseLogisticsUser
    default:
      return false
  }
}

export function getVisibleFeatureAnnouncements(userInfo: any) {
  const toJoyrideStep = (feature: any) => ({
    target: 'body',
    placement: 'center',
    content: (
      <>
        <div>
          <div className="hc-ta-center">
            <div>
              <h3 className="hc-color-black">{feature.title}</h3>
              {renderCardMedia(feature)}
            </div>
          </div>
          {feature.description}
        </div>
      </>
    ),
  })

  // Filter out steps that have SURVEY_ENABLED role
  const filteredSteps = newLocationUpdateFeatures.filter(
    (step) => !(step.visibleTo && step.visibleTo.includes('SURVEY_ENABLED')),
  )

  if (userInfo.isInternal) return filteredSteps.map(toJoyrideStep)

  // Other users see features based on visibleTo
  return filteredSteps
    .filter(
      (step) =>
        !step.visibleTo ||
        step.visibleTo.includes('ALL') ||
        step.visibleTo.some((role) => userHasRole(userInfo, role)),
    )
    .map(toJoyrideStep)
}
